import type { InvoiceItemInput } from "@/types";

/**
 * Parse pasted invoice text into structured line items.
 *
 * One description per line. An optional trailing price (with or without `$`)
 * is extracted as `unit_price_usd`. Blank lines are ignored.
 *
 * Examples:
 *   "DHPP vaccine"           → { description: "DHPP vaccine" }
 *   "DHPP vaccine 25.00"     → { description: "DHPP vaccine", unit_price_usd: 25 }
 *   "Physical exam, $75"     → { description: "Physical exam", unit_price_usd: 75 }
 */
export function parseInvoiceLines(raw: string): InvoiceItemInput[] {
  return raw
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const priceMatch = line.match(/\$?\s*(\d+(?:\.\d+)?)\s*$/);
      if (priceMatch) {
        const description = line.slice(0, priceMatch.index).trim().replace(/[,\s]+$/, "");
        return { description, unit_price_usd: Number(priceMatch[1]) };
      }
      return { description: line };
    });
}
